import {
  AMEX,
  Mastercard,
  Visa,
} from '@unified-checkout/design-system/icons/payment_methods';

export const methods = [
  { name: 'mastercard', icon: Mastercard },
  { name: 'visa', icon: Visa },
  { name: 'amex', icon: AMEX },
];
